/**
 * Recursively filters out null, undefined, and objects/arrays that only contain null/undefined.
 * Returns `undefined` when the entire structure is empty after filtering, so callers can
 * decide whether to render anything at all.
 */
export default function filterNullsAndUndefined(obj: unknown): unknown {
  if (obj === null || obj === undefined) {
    return undefined;
  }

  if (Array.isArray(obj)) {
    const filtered = obj.map((item) => filterNullsAndUndefined(item)).filter((item) => item !== undefined);
    return filtered.length > 0 ? filtered : undefined;
  }

  if (typeof obj === 'object') {
    const filtered: Record<string, unknown> = {};
    let hasValidValue = false;

    for (const [key, value] of Object.entries(obj)) {
      const filteredValue = filterNullsAndUndefined(value);
      if (filteredValue !== undefined) {
        filtered[key] = filteredValue;
        hasValidValue = true;
      }
    }

    return hasValidValue ? filtered : undefined;
  }

  return obj;
}
